module.exports = __webpack_public_path__ + "media/images/admin/icons/filter-f342dd7b00319746f418bb18b1da51c3.svg";